import * as actionTypes from './constants'

const initialState = {
  hubspotAttributeFields: null,
  hubspotAttributeMappings: [],
  hubspotAttributeMappingsErr: null,
  hubspotAttributePatching: false,
  hubspotUsers: [],
  hubspotUserMappings: [],
  hubspotUserMappingsErr: null,
  hubspotUserMappingLoading: false,
  hubspotUserMappingLoaded: false,
  hubspotUserMappingsPatchLoading: false,
  hubspotUsersSearchLoading: false,
  hubspotUsersSearchLoaded: false,
  hubspotResponse: {}
}

const sortedByStatic = mappings => _.sortBy(mappings, mapping => !mapping.static)

const handleUserMappings = ({ hubspotUsers }, { mappings, users }) => ({ 
  hubspotUserMappings: mappings,
  hubspotUsers: _.uniqBy([...hubspotUsers, ...users], 'id')
})

const hubspotMappings = function (state = initialState, action) {
  const { hubspotResponse } = state
  switch (action.type) {
    case actionTypes.FETCH_HUBSPOT_FIELDS_SUCCESS:
      return Object.assign({}, state, { hubspotAttributeFields: action.fields })

    case actionTypes.FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS:
      const clonedState = Object.assign({}, state)
      clonedState.hubspotAttributeMappings = sortedByStatic(action.mappings)
      clonedState.allowAttributeDefaults = action.allowAttributeDefaults
      clonedState.useCountryAcronyms = action.useCountryAcronyms
      clonedState.useStateAcronyms = action.useStateAcronyms
      return clonedState

    case actionTypes.PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS:
      return Object.assign({}, state, {
        hubspotAttributeMappings: sortedByStatic(action.mappings),
        allowAttributeDefaults: action.allowAttributeDefaults,
        useCountryAcronyms: action.useCountryAcronyms,
        useStateAcronyms: action.useStateAcronyms,
        hubspotAttributeMappingsErr: null,
        hubspotAttributePatching: false
      })

    case actionTypes.PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR:
      return Object.assign({}, state, { hubspotAttributeMappingsErr: action.err, hubspotAttributePatching: false })

    case actionTypes.PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START:
      return Object.assign({}, state, { hubspotAttributePatching: true })

    case actionTypes.FETCH_HUBSPOT_USERS_SEARCH_SUCCESS:
      return Object.assign({}, state, 
        { 
          hubspotUsersSearchLoaded: true,
          hubspotUsersSearchLoading: false,
          hubspotUsers: _.uniqBy([...state.hubspotUsers, ...action.users], 'id') 
        }
      )

    case actionTypes.FETCH_HUBSPOT_USERS_SEARCH_ERROR:
      return Object.assign({}, state, { hubspotUsersSearchLoading: false, hubspotUsersSearchLoaded: false })

    case actionTypes.FETCH_HUBSPOT_USERS_SEARCH_START:
      return Object.assign({}, state, { hubspotUsersSearchLoading: true, hubspotUsersSearchLoaded: false })

    case actionTypes.FETCH_HUBSPOT_USER_MAPPINGS_STARTED:
      return Object.assign({}, state, {
        hubspotUserMappingLoading: true,
        hubspotUserMappingLoaded: false,
      })

    case actionTypes.PATCH_HUBSPOT_USER_MAPPINGS_START:
      return Object.assign({}, state, { hubspotUserMappingsPatchLoading: true })

    case actionTypes.PATCH_HUBSPOT_USER_MAPPINGS_SUCCESS:
      return Object.assign({}, state, {
        hubspotUserMappingsPatchLoading: false,
        ...handleUserMappings(state, action)
      })

    case actionTypes.PATCH_HUBSPOT_USER_MAPPINGS_FAILED:
      return Object.assign({}, state, { hubspotUserMappingsErr: action.err, hubspotUserMappingsPatchLoading: false })

    case actionTypes.FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS:
      return Object.assign({}, state, {
        hubspotUserMappingLoading: false,
        hubspotUserMappingLoaded: true,
        ...handleUserMappings(state, action)
      })

    case actionTypes.FETCH_HUBSPOT_BY_EMAIL_STARTED:
      hubspotResponse[action.key] = {
        loading: true,
        error: {},
        data: {},
      }
      return Object.assign({}, state, { hubspotResponse: hubspotResponse })

    case actionTypes.FETCH_HUBSPOT_BY_EMAIL_FAILED:
      hubspotResponse[action.key] = {
        loading: false,
        error: action.err,
        data: {},
      }
      return Object.assign({}, state, { hubspotResponse: hubspotResponse })

    case actionTypes.FETCH_HUBSPOT_BY_EMAIL_SUCCESS:
      hubspotResponse[action.key] = {
        loading: false,
        error: {},
        data: action.data,
      }
      return Object.assign({}, state, { hubspotResponse: hubspotResponse })

    default:
      return state
  }
}

export default hubspotMappings



// WEBPACK FOOTER //
// ./src/scripts/app/modules/hubspot/reducer.js